import React from 'react';
import Config from '../../lib/Config';
import '../../assets/style/fonts.css';
//import {useNavigate} from 'react-router-dom';
import { useEffect, useState } from 'react';
import Util from '../../lib/Util';
import TopBar from '../../lib-ui/TopBar';











export default () => {

    //const navigate = useNavigate();
    const [lang,setLang] = useState(Config.SERVICE_DEFAULT_LANGUAGE);

    useEffect(()=>{
        setLang(Util.get_url_lang());
    },[]);









    return (
        <div style={{width:'100vw',height:'98vh',fontFamily:'Roboto',fontSize:'13px'}}>
        <TopBar lang={lang} page={'login'} />

       <div style={{fontSize:'13px',justifyContent:'center',margin:'100px',cursor:'pointer'}} onClick={()=>{ /*navigate('/'+lang+'/individual/signup');*/ }}>Individual Login</div>
       <div style={{fontSize:'13px',justifyContent:'center',margin:'100px',cursor:'pointer'}} onClick={()=>{ /*navigate('/'+lang+'/corp/login');*/ }}>Corp Login</div>

       <div style={{width:'80%',height:'100px',position:'fixed',bottom:'0',paddingTop:'11px',fontFamily:'Roboto',fontSize:'11px',paddingLeft:'30px',textAlign:'left',color:'#222222',lineHeight:'20px'}}>NSTRUCT Inc.<br />All rights reserved&copy;2018-2024</div>
        </div>
    );

}